<!-- Display everything in a form field -->
<mat-form-field *ngIf="settings">

    <!-- Use default angular mat select as base -->
    <mat-select [placeholder]="settings.placeholder || 'Make selection'" [formControl]="settings.control"
        (openedChange)="searchInput.focus(); $event ? opened() : closed()" [compareWith]="compareWith"
        panelClass="mat-menu-overlay-selector">

        <!-- Search -->
        <div class="search flex items-center" [ngClass]="{'hidden': settings.hideSearch}">
            <input i18n-placeholder placeholder="Typ om te zoeken..." class="search-input" [formControl]="searchControl"
                #searchInput (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <button mat-icon-button *ngIf="!isLoading && searchControl.value"
                (click)="searchControl.reset(''); searchInput.focus();" class="fade">
                <mat-icon svgIcon="x"></mat-icon>
            </button>
        </div>

        <!-- Filtered items from query. Displayed in a virtual scroll -->
        <cdk-virtual-scroll-viewport [itemSize]="rowHeight" [minBufferPx]="rowHeight * maxRows"
            [maxBufferPx]="rowHeight * (maxRows + 2)"
            [style.height]="(cache.length > maxRows ? (maxRows * rowHeight) : (cache.length * rowHeight)) + 'px'">
            <!-- Display mat option for each item -->
            <mat-option *cdkVirtualFor="let item of cache" [disabled]="isDisabled(item)" [value]="item"
                class="mat-option">
                <ng-container *ngTemplateOutlet="matOptionContent, context: {$implicit: item}"></ng-container>
                <span *ngIf="!matOptionContent">{{item[searchProperties[0]]}}</span>
            </mat-option>
            <!-- Display load more row if necessary -->
            <div *ngIf="cache.length !== total" class="count flex flex-row justify-between items-center px-5">
                <p class="text-sm text-gray-300">{{cache.length}} / {{total}} resultaten geladen</p>
                <p (click)="loadMore()" *ngIf="!loadMoreOnScroll" class="text-app-global-tertiary cursor-pointer" i18n>
                    Laad
                    meer
                </p>
            </div>
        </cdk-virtual-scroll-viewport>

        <!-- No values matching search  -->
        <div class="no-values-warning" *ngIf="!cache.length">
            <p i18n>Geen resultaten gevonden </p>
        </div>

        <!-- Hidden mat-option for selected item in single select mode -->
        <mat-option *ngIf="settings.control.value" [value]="settings.control.value" class="hidden">
            <ng-container
                *ngTemplateOutlet="matOptionContent, context: {$implicit: settings.control.value}"></ng-container>
            <span *ngIf="!matOptionContent">{{settings.control.value[searchProperties[0]]}}</span>
        </mat-option>
    </mat-select>

    <!-- Clear button -->
    <mat-icon matSuffix class="clear-form-field" *ngIf="settings.control.value && !settings.hideClear"
        (click)="$event.stopPropagation(); settings.control.reset()" svgIcon="x"></mat-icon>

    <!-- Mat error shown when settings.control is in invalid state -->
    <mat-error *ngIf="settings.invalidControlErrorMessage" i18n>{{settings.invalidControlErrorMessage}}</mat-error>
</mat-form-field>